import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { Globals } from '../../_models/globals';

import { NotificationService } from '../../_services/notification.service';
import { LogoutUserService } from './logout-user.service';
import { SuportGridviewSort, SupportGridview, SupportGridviewTableBodyCell, SupportGridviewTemplateCell } from '../_models/supportGridview';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { UserData } from './_models/userData';

declare const isEmpty: any;

@Component({
    selector: 'app-logout-user', templateUrl: './logout-user.component.html', styleUrls: ['./logout-user.component.scss'],
    standalone: false
})
export class SupportLogoutUserComponent implements OnDestroy, OnInit {
    private _sortSubscription: Subscription;

    public config: SupportGridview = new SupportGridview();
    public templatesArray: SupportGridviewTemplateCell[] = [];

    public usersDataList: UserData[] = [];

    public filter: string = '';

    constructor(private logoutUserService: LogoutUserService, private notificationService: NotificationService, private globals: Globals, private ngxLoader: NgxUiLoaderService) {}

    ngOnInit(): void {
        this._sortSubscription = this.logoutUserService.sortDataValue$.subscribe(value => this.config.sort = value);

        this.config.set({
            actions: {
                edit:   { enable: false },
                action: { enable: false },
                remove: { enable: true, confirmationText: 'support.desconectar-usuarios.table.icon-button.confirm', tooltipText: 'support.desconectar-usuarios.table.icon-button.tooltip' },
            },
            emptyText: { isHtml: false, value: 'support.desconectar-usuarios.table.empty.before-search' },
            list: [],
            sort: this.logoutUserService.getSortDataValue(),
            table: {
                body: [
                    new SupportGridviewTableBodyCell('col-0-25 text-center', 'userId'),
                    new SupportGridviewTableBodyCell('col-5 truncate-gridview', 'userName')
                ],
                header: [
                    { className: 'col col-0-25 text-center', sortName: 'userId',  value: 'support.desconectar-usuarios.table.title.id' },
                    { className: 'col col-5', sortName: 'userName', value: 'support.desconectar-usuarios.table.title.username' },
                    { className: 'col col-0-25 text-center', value: '' }
                ]
            },
            hasSmallActions: true
        });
    }

    ngOnDestroy(): void {
        if (!this._sortSubscription?.closed)
            this._sortSubscription.unsubscribe();
    }

    getUsers() {
        if (isEmpty(this.filter)) {
            this.handleDataSet([]);
            return;
        }

        this.ngxLoader.startLoader('loader-principal');

        this.logoutUserService.getUsers(this.filter).subscribe({
            next: (response: ApiResponseModel<UserData[]>) => {
                this.handleDataSet(response.result);

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: (error) => {
                this.notificationService.showErrorToastr('support.desconectar-usuarios.messages.error.load', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    async logoutAll() {
        const confirm = await this.notificationService.showConfirmationDialog('support.desconectar-usuarios.header.buttons.logout-all.confirm');

        if (!confirm)
            return;

        this.ngxLoader.startLoader('loader-principal');

        this.logoutUserService.logoutAll().subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                this.handleDataSet([]);

                this.notificationService.showSuccessToastr('support.desconectar-usuarios.messages.success.logout-all', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            },
            error: (error) => {
                this.notificationService.showErrorToastr('support.desconectar-usuarios.messages.error.logout-all', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    logoutUser(userId: number) {
        this.ngxLoader.startLoader('loader-principal');

        this.logoutUserService.logoutUser(userId).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                this.getUsers();
                this.notificationService.showSuccessToastr('support.desconectar-usuarios.messages.success.logout-user', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            },
            error: (error) => {
                this.notificationService.showErrorToastr('support.desconectar-usuarios.messages.error.logout-user', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    handleDataSet(usersDataList: UserData[]) {
        this.usersDataList = usersDataList;
        this.config.list = this.usersDataList;
    }

    onSearch($event: string) {
        this.filter = $event;
        this.config.emptyText = { isHtml: false, value: 'support.desconectar-usuarios.table.empty.' + (isEmpty(this.filter) ? 'before-search' : 'after-search') },

        this.getUsers();
    }

    onSort(sortData: SuportGridviewSort) {
        this.logoutUserService.setSortDataValue(sortData);
    }
}
